import { render, staticRenderFns } from "./RegionPage.vue?vue&type=template&id=eb29f730"
import script from "./RegionPage.vue?vue&type=script&lang=js"
export * from "./RegionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports